// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import your header (always visible)
import Header from './Header';
import Home from './Home';

// Import your pages
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import FlightTracker from './pages/FlightTracker';
import Dashboard from './pages/Dashboard';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Quote from './pages/Quote';
import Language from './pages/language';

function App() {
  return (
    <Router>
      {/* Header with Burger Menu + Sidebar always visible */}
      <Header />

      {/* Define our pages using Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/language" element={<Language />} />
        <Route path="/about" element={<About />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/flight-tracker" element={<FlightTracker />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;